import { motion } from "framer-motion";

const ease = [0.7, 0, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1, delay, ease }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ over, title, title2, sub, id }) => (
  <Reveal className="max-w-4xl">
    <p className="eyebrow mb-8" data-testid={`${id}-overline`}>{over}</p>
    <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
      {title} <em className="text-gold italic font-normal">{title2}</em>
    </h2>
    {sub && <p className="mt-8 text-stone text-base md:text-lg max-w-xl leading-relaxed">{sub}</p>}
  </Reveal>
);
